import React, { useState } from "react";
import "./snipet.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const Snipet = () => {
  const [notifyEmail, setNotifyEmail] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const url = "https://backend.goldengirlsonthemove.com";

    if (!notifyEmail) {
      toast.error("Please provide an email address.");
      setIsSubmitting(false);
      return;
    }

    if (!validateEmail(notifyEmail)) {
      toast.error("Please enter a valid email address.");
      setIsSubmitting(false);
      return;
    }

    try {
      console.log("Checking email");
      const result = await axios.get(`${url}/api/check_added_email`, {
        params: { email: notifyEmail, table: "notify" },
      });

      if (result.data.Status) {
        // Assuming result.data.Status indicates email exists
        toast.error("Email already exists. Thank you for your registration.");
        setIsSubmitting(false);
        return; // Stop further execution if email exists
      }
    } catch (err) {
      console.error("Axios error:", err);
      console.log("Here at check");
      setIsSubmitting(false);
      toast.error("An error occurred while checking the email. Please try again later.");
      return; // Stop further execution in case of an error
    }

    try {
      console.log("notifyEmail", notifyEmail);
      const res = await axios.post(`${url}/api/notify`, { notifyEmail });
      if (res.status === 200) {
        // alert("Email sent successfully");
        toast.success("Thank you! We will notify you for the launch.");
        setIsSubmitting(false);
        setNotifyEmail("");
      } else {
        toast.error("An error occurred while processing your request. Please try again later."
        );
        setIsSubmitting(false);
        return;
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        "An error occurred while processing your request. Please try again later."
      );
      setIsSubmitting(false);
      return;
    }
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  return (
    <div className="snipet">
      <div className="insight_div">
        <h2>WHAT WE DO</h2>
        <h3>Latests Blogs & Events</h3>
        <p>
          <a href="/blog">READ OUR BLOGS</a>
        </p>
        <p>
          <a href="/events">NEWS & REPORTS</a>
        </p>
      </div>
      <div className="articles_div">
        <div className="new_blog_articles">
          <div className="new_blog_article">
            <h3>EVENTS . FEBRUARY 26, 2025</h3>
            <h4>Mary's Ultra Run - 60 @ 60</h4>
            <Link to="/mary60@60">Join our founder, Dr. Mary Amuyunzu as she tests her limit on a 60KM trail!</Link>
            <div className="notifyLaunchDiv">
              <button class="notifyBtn" onClick={() => (window.location.href = '/mary60@60')}>Register</button>
            </div>
          </div>

          <div className="new_blog_article">
            <h3>EVENTS . FEBRUARY 8, 2024</h3>
            <h4>Golden Girls on The move launch</h4>
            <Link to="/events">Stay tuned for our launch. Coming soon!</Link>
            <div className="notifyLaunchDiv">
              <p>NOTIFY ME!</p>
              <input
                type="email"
                className="notify__email"
                name="notifyEmail"
                placeholder="Enter Your Email"
                value={notifyEmail}
                onChange={(e) => setNotifyEmail(e.target.value)}
              ></input>
              <button class="notifyBtn" onClick={handleSubmit} disabled={isSubmitting}>{isSubmitting ? "Submitting..." : "Submit"}</button>
            </div>
          </div>
        </div>
        <hr />
        <div className="new_blog_articles">
          <h3>BLOG . FEBRUARY 8, 2024</h3>
          <h4>Exercise at 50+, what to expect</h4>
          <Link to="/blog">Benefits of being physically active at 50+</Link>
        </div>
        <hr />
      </div>
    </div>
  );
};

export default Snipet;
